import { render, staticRenderFns } from "./CompraV.vue?vue&type=template&id=0b2508ae"
import script from "./CompraV.vue?vue&type=script&lang=js"
export * from "./CompraV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports